export default __webpack_public_path__ + "static/media/bear-green.ed8ac776.svg";